import React from 'react';
import { Avatar, Box, Card, CardContent, makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import { Coach } from 'src/models/Common';

import { generateInitials } from '../../../../helpers/generateInitials';
import { colors } from '../../../../themes/colors';

const styles = makeStyles({
  card: {
    display: 'flex',
  },
  image: {
    marginLeft: 2,
  },
  content: {
    padding: '10px !important',
  },
  providerName: {
    fontSize: 14,
    fontWeight: 800,
    color: colors.black3,
  },
  providerType: {
    fontSize: 12,
    fontWeight: 500,
    color: colors.black5,
  },
});

interface Props {
  provider: Coach;
}

const CareTeamProviderCard: React.FC<Props> = ({ provider }) => {
  const classes = styles();

  return (
    <Card elevation={0} className={classes.card}>
      <Box display="flex" flexDirection="row">
        <Box display="flex" alignItems="center" className={classes.image}>
          {provider.avatar && <Avatar src={provider.avatar} />}

          {!provider.avatar && provider.firstName && provider.lastName && (
            <Avatar>{generateInitials([provider.firstName, provider.lastName])}</Avatar>
          )}
        </Box>

        <CardContent className={classes.content}>
          <Typography className={classes.providerName}>
            {provider.firstName} {provider.lastName}
          </Typography>

          <Typography className={classes.providerType}>
            {provider.psychiatristSubtype || provider.providerType}
          </Typography>
        </CardContent>
      </Box>
    </Card>
  );
};

export default CareTeamProviderCard;
